/**
 * WebSocket closure codes
 * For detailed description, see: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
 */
export const GcsWebSocketClosureCodes = {
  // Standard codes
  NORMAL_CLOSURE: 1000,
  GOING_AWAY: 1001,
  NO_STATUS_RECEIVED: 1005,
  ABNORMAL_CLOSURE: 1006,
  INTERNAL_ERROR: 1011,
  SERVICE_RESTART: 1012,
  TRY_AGAIN_LATER: 1013,
  BAD_GATEWAY: 1014,

  // Reconnection NOT required (4000-4099)
  // Actions by another user
  USER_EDITED: 4100, // The user has been edited by another user
  USER_DELETED: 4101, // The user has been deleted by another user

  // Problems with the session key
  SESSION_KEY_EXPIRED: 4010, // The browser session key has expired (cookie is no longer valid)
  SESSION_KEY_RESET: 4011, // The session key has been reset (i.e. due to login)
  SESSION_KEY_INVALID: 4012, // The session key is not valid (possibly expired/removed)

  // Actions by the user
  USER_CONNECTED_IN_OTHER_CLIENT: 4001, // The user has opened another connection; single-connection-per RPIC policy
  USER_LOGGED_OUT: 4020, // The user has logged out

  // Internal errors
  ALREADY_CLOSED: 4030,

  // Other
  OTHER_DO_NOT_RECONNECT: 4099, // Other error; do not try reconnecting

  // Reconnection required (4100-4199)
  OTHER_RECONNECT: 4199 // Other error; try reconnecting
} as const;
